import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateProject from "Projects/routes/CreateProject";
import ProjectDetails from "Projects/routes/ProjectDetails";
import Timeline from "./routes/Timeline";
export default store => {
  return {
    path: "studentPortfolio",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "project-group" */ "./StudentPortfolio.js"
          ),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [CreateProject(store), Timeline(store), ProjectDetails(store)],
  };
};
